var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-list-person auto-list_col_centered"},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.response.request_phone))])])}
var staticRenderFns = []

export { render, staticRenderFns }